// extracted by mini-css-extract-plugin
export default {"triggerButton":"WS4ZZFdK","root":"ZPyzhNNN","logo":"MKWZSnMb"};